export default __webpack_public_path__ + "static/media/no_image.0056de2e.jpeg";